// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-1iDK9";
var _4 = "group-21kSA";
var _5 = "group__field-3M1OC";
var _6 = "loyaltyConnect-3mPey";
var _7 = "group__field_switch-ahXfF";
var _8 = "login__modal_content-2hvxI";
var _9 = "buttons__wrapper-3JADS";
var _a = "forgotPassword__header-2v3bh";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "group", _5 as "group__field", _6 as "loyaltyConnect", _7 as "group__field_switch", _8 as "login__modal_content", _9 as "buttons__wrapper", _a as "forgotPassword__header" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "group": _4, "group__field": _5, "loyaltyConnect": _6, "group__field_switch": _7, "login__modal_content": _8, "buttons__wrapper": _9, "forgotPassword__header": _a }
